exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.pagination-container[data-v-72233bcd] {\r\n  background: #fff;\r\n  margin-top: 12px;\n}\n.pagination-container.hidden[data-v-72233bcd] {\r\n  display: none;\n}\n.pagination-container .el-pagination[data-v-72233bcd]{\r\n  padding: 0 !important;\n}\r\n", ""]);

// exports
